import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { lineChartData, lineChartOptions } from "../../variables/charts";
import { ApexChartSeries } from "../../types/charts";

interface LineChartProps {
  // Add any props if needed in the future
}

interface LineChartState {
  chartData: ApexChartSeries[];
  chartOptions: ApexOptions;
}

class LineChart extends Component<LineChartProps, LineChartState> {
  constructor(props: LineChartProps) {
    super(props);

    this.state = {
      chartData: lineChartData || [],
      chartOptions: lineChartOptions as ApexOptions || {},
    };
  }

  componentDidMount(): void {
    // Always set the data to ensure it's loaded
    this.setState({
      chartData: lineChartData,
      chartOptions: lineChartOptions as ApexOptions,
    });
  }

  render(): JSX.Element | null {
    const { chartData, chartOptions } = this.state;
    
    // Use imported data directly if state is empty
    const dataToUse = (chartData && chartData.length > 0) ? chartData : lineChartData;
    const optionsToUse = (chartOptions && Object.keys(chartOptions).length > 0) ? chartOptions : (lineChartOptions as ApexOptions);
    
    // Basic validation
    if (!dataToUse || !Array.isArray(dataToUse) || dataToUse.length === 0) {
      return null;
    }
    
    if (!optionsToUse || typeof optionsToUse !== 'object') {
      return null;
    }
    
    // Render chart - use options as-is since data structure is correct
    return (
      <ReactApexChart
        options={optionsToUse}
        series={dataToUse}
        type="area"
        width="100%"
        height="100%"
      />
    );
  }
}

export default LineChart;

